import type { TProgrammingDateRangeInputs } from "@/components/piloting/planning/programming-range/date-range-inputs/programming-date-range-inputs.types";
import type { ProgramId } from "@/data/common/ids";
import type { UpdateSiteSectionProgrammingRangeRequest } from "@/domains/v4b/site-programming-range/site-programming-range.types";
import type { ProgrammingRange } from "@/domains/v4b/site-programming-range/site-programming-range.types";

import { isDefined } from "@voltalis/frontend-utils";

export function buildProgrammingRangeUpdateRequest(
  programmingRange: ProgrammingRange,
  selectedProgramId: ProgramId,
  dateRange: Partial<TProgrammingDateRangeInputs>,
): UpdateSiteSectionProgrammingRangeRequest | undefined {
  const hasProgramChange = selectedProgramId !== programmingRange.program.id;
  const hasStartChange = isDefined(dateRange.start);
  const hasEndChange = dateRange.end !== undefined;
  if (!hasProgramChange && !hasStartChange && !hasEndChange) return undefined;

  const request: UpdateSiteSectionProgrammingRangeRequest = {
    programmingRangeUuid: programmingRange.uuid,
    programId: selectedProgramId,
  };

  if (hasStartChange) request.start = dateRange.start;
  if (hasEndChange) request.end = dateRange.end;

  return request;
}
